import Button from "@mui/material/Button"
import React from "react"
import { Link, LinkProps, useLocation, useResolvedPath } from "react-router-dom"

type UiButtonProps = {
  className?: any
  style?: any
  size?: "small" | "medium" | "large"
  icon?: React.ElementType
  children?: React.ReactNode
  [key: string]: any
}

const buttonClassName = (size: UiButtonProps["size"]) =>
  `d-flex justify-center items-center pl-2 pr-2 ${size === "small" ? "min-w-8 h-8" : size === "medium" ? "min-w-10 h-10" : "min-w-14 h-14"}`

export const UiButton = ({ className, size = "medium", icon: IconComponent, children, ...props }: UiButtonProps) => (
  <Button variant="ui-element" className={buttonClassName(size) + (className ? ` ${className}` : "")} {...props}>
    {!!IconComponent && <IconComponent className={React.Children.count(children) > 0 ? "mr-1" : ""} />}
    {children}
  </Button>
)

type UiLinkProps = UiButtonProps &
  LinkProps & {
    activeProps?: any
  }

export const UiLink = ({
  style: styleProp,
  className: classNameProp,
  variant: variantProp = "ui-element",
  to,
  end,
  caseSensitive: _caseSensitive,
  activeProps,
  ...props
}: UiLinkProps) => {
  const path = useResolvedPath(to, { relative: props.relative })
  const location = useLocation()
  const locationPathname = location.pathname
  const toPathname = path.pathname
  const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length
  const isActive =
    locationPathname === toPathname ||
    (!end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/")

  const className = typeof classNameProp === "function" ? classNameProp({ isActive }) : classNameProp
  const style = typeof styleProp === "function" ? styleProp({ isActive }) : styleProp
  const variant = typeof variantProp === "function" ? variantProp({ isActive }) : variantProp
  const additionalProps = isActive ? (typeof activeProps === "function" ? activeProps() : activeProps) : {}

  return (
    <UiButton
      {...props}
      component={Link}
      to={to}
      end={end}
      className={className}
      variant={variant}
      style={style}
      {...additionalProps}
    />
  )
}
